module.exports = __webpack_public_path__ + "static/media/Class Recordings.b0c677f7.png";